import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Form } from 'src/app/assabil-kernel/models/entities/control-tables/form';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { TermLovComponent } from '../term-lov/term-lov.component';


@Component({
  selector: 'form-list',
  templateUrl: './form-list.component.html',
  styleUrls: ['./form-list.component.scss']
})

export class FormListComponent extends BasePage2<Form> {

  forms     : Form[] = [];
  code      : string;
  name      : string;

  constructor(   
    protected toastr                : ToastrService,
    protected router                : Router,
    protected controlTablesService  : ControlTablesService,
    protected baseService           : BaseService,
    protected leanUtilsService      : LeanUtilsService,
    protected location              : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "form";
  }


//----------------------------------------------------------------------
ngAfterViewInit(): void {
  super.ngAfterViewInit();
    this.setChildFields();
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
setChildFields(){
      this.baseService.fieldsGet('formField').then(result => {
            this.childFields = result.listFields;
            this.readOnly    = result.readOnly;

            this.childFields.forEach(field => {
                if (field.prop == 'term.termCode') {
                  field.modal = TermLovComponent;
                }
            })

      }) 
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
getRows(): Form[] {
      return this.forms;
  }
//----------------------------------------------------------------------



//----------------------------------------------------------------------
new(){
  let form : Form = new Form();
  form.inserted = true;
  form.edit     = true;
  this.selectedRow = form;
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  loadData() {    
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;
    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.forms = result;
    })
  }
// ---------------------------------------------------
  
//----------------------------------------------------------------------
selectRow(form : Form){
  let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
  request.strArg1 = form.formCode;
  this.controlTablesService.getSingle(this.entityName, request).then(result => {
      this.selectedRow = result;
  })
}
//----------------------------------------------------------------------

}
